import React from 'react';

import CreateCollectionForm from './CollectionsList/CreateCollectionForm';

interface CreateCollectionViewProps {
  onBack: () => void;
  onSaveSuccess: () => void;
}

export const CreateCollectionView: React.FC<CreateCollectionViewProps> = ({
  onBack,
  onSaveSuccess,
}) => {
  return (
    <div className="max-w-[944px] p-6 rounded-2xl">
      <div className="bg-white rounded-xl shadow-sm bg-white-100 p-6">
        <CreateCollectionForm onCancel={onBack} onSaved={onSaveSuccess} />
      </div>
    </div>
  );
};

export default CreateCollectionView;
